export const VIDEO_QUERY_KEY = 'video' as const;

/** Page size for the clip listing. */
export const VIDEO_PAGE_LIMIT = 500;

// Viewer/inspector split, sized as a fraction of the workspace row — same bounds as
// the MCAP workspace so the two asset pages resize identically.
export const VIEWER_PANE_MIN_FRACTION = 0.38;
export const VIEWER_PANE_MAX_FRACTION = 0.78;
export const VIEWER_PANE_INITIAL_FRACTION = 0.7;

/** Skip distance for the ←/→ playback shortcuts. */
export const SKIP_SECONDS = 5;

/** Frame rate assumed for single-frame stepping when the probe reported no fps. */
export const FALLBACK_FPS = 30;

/**
 * How close `video.currentTime` must already be to a requested position for the seek to
 * be considered satisfied. A seek lands on the nearest decodable frame rather than the
 * exact requested time, so without a tolerance a scrub would re-issue itself forever.
 */
export const SEEK_TOLERANCE_SECONDS = 0.15;

/**
 * hls.js buffer configuration, ported from the v1 player: a short forward buffer keeps
 * scrubbing responsive on long renditions, and `capLevelToPlayerSize` avoids pulling a
 * 4K variant into a half-width pane.
 */
export const HLS_CONFIG = {
  maxBufferLength: 8,
  backBufferLength: 10,
  capLevelToPlayerSize: true,
} as const;

/**
 * Minimum spacing between signature-expiry recoveries. A single expired lease makes
 * *every* in-flight segment request fail at once, so without a floor one expiry would
 * fan out into a burst of manifest fetches.
 */
export const SIGNATURE_REFRESH_THROTTLE_MS = 5_000;

/** Consecutive signature recoveries before we stop retrying and surface a fatal error. */
export const MAX_SIGNATURE_REFRESH_ATTEMPTS = 2;

/**
 * Technical detail shown when signature recovery is exhausted. It takes the place of an
 * `hls.js` `data.details` string in the player's fatal alert, so it stays an untranslated
 * diagnostic token like the ones hls.js itself emits.
 */
export const SIGNATURE_FATAL_DETAIL = 'hlsSignatureRefreshExhausted';

/** Timeline lane height and label-gutter width (matches the MCAP timeline). */
export const CLIP_LANE_HEIGHT = 44;
export const CLIP_LANE_LABEL_WIDTH = 180;
